'use client'

import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'
import type { User } from '@/shared/types/user'

export interface UseFollowingResult {
  records: User[]
  isLoading: boolean
  error: Error | null
  refetch: () => void
}

export function useFollowing(options?: { enabled?: boolean }): UseFollowingResult {
  const { records, isLoading, error, refetch } = useOptimizedRecords<User>({
    path: '/user/follows/following',
    enabled: options?.enabled ?? true
  })

  return {
    records,
    isLoading,
    error: error ?? null,
    refetch
  }
}
